import React from 'react'
import { authRoles } from 'app/auth/authRoles'

const telephonySettingsRoutes = [
    {
        path: '/Settings/Telephony',
        component: React.lazy(() => import('./TelephonySettingsPage')),
        auth: authRoles.admin,
        accessPageName: 'SETTINGS',
    },
]

export default telephonySettingsRoutes

